import React from "react";
import "./VtplOptionComponentStyles.scss";
import classNames from "classnames";
import {premiumFormat, sumInsuredFormat} from "../../../../utils/format";
import {strings} from "../../../../strings/strings";
import {SimpleTooltip} from "../../../../components/SimpleTooltip";
import {ReactSVG} from "react-svg";
import info_red from "../../../../images/info_red.svg";
import {translit} from "../../../../utils/utils";

interface VTPLOptionComponent {
    id?: string
    premium: number;
    sumInsured: number;
    selected: boolean;
    error: boolean;
    onSelect: (sumInsured: number, premium: number) => void;
    isSmartDrive: boolean;
    totalPremium: number;
}

export const VTPLOptionComponent = ({
                                        error,
                                        selected,
                                        onSelect,
                                        sumInsured,
                                        premium,
                                        id,
                                        totalPremium,
                                        isSmartDrive
                                    }: VTPLOptionComponent) => {
    const className = classNames({
        'vtpl-option': true,
        'vtpl-option_selected': selected,
        'vtpl-option_error': error
    });

    return (
        <div className={className} onClick={() => onSelect(sumInsured, premium)}>
            <div id={'vtplOptions_' + id} className='vtpl-option__sum-insured'>
                <span>{`${sumInsuredFormat(sumInsured)} ${strings.currencyUAH}`}</span>
            </div>

            <div className={'vtpl-option__premium'}>
                <span>{`+ ${premiumFormat(premium)} ${strings.currencyUAH}`}</span>
                {isSmartDrive && <SimpleTooltip id={translit(strings.salesPackageInfo.text1)} title={
                    <span>{strings.salesPackageInfo.text1}
                        <span className={"accent"}>{strings.salesPackageInfo.text2}</span>
                        {strings.salesPackageInfo.text3}
                        <span className={"accent"}>{`${premiumFormat(totalPremium)}`}</span>
                        {strings.salesPackageInfo.text4}
                    </span>} placement={"top"}>
                    {<ReactSVG src={info_red}/>}
                </SimpleTooltip>
                }
            </div>
        </div>
    )
};